import React from "react";
import { Popup } from "semantic-ui-react";

import Dashboard from "../assets/svg/svg_icons/dashboard_white.svg";
import Cashflow from "../assets/svg/svg_icons/cashflow_white.svg";
import Reconcile from "../assets/svg/svg_icons/reconcile_white.svg";
import Nomina from "../assets/svg/svg_icons/nomina_white.svg";
import Documents from "../assets/svg/svg_icons/documents_white.svg";
import Credits from "../assets/svg/svg_icons/credits_white.svg";
import Passwords from "../assets/svg/svg_icons/passwords_white.svg";
import Agenda from "../assets/svg/svg_icons/agenda_white.svg";
import Reports from "../assets/svg/svg_icons/reports_white.svg";
import LogOut from "../assets/svg/svg_icons/log_out_white.svg";
import Settings from "../assets/svg/svg_icons/settings_white.svg";
import Cobranza from "../assets/svg/svg_icons/cobranza.svg"
import F29 from "../assets/svg/svg_icons/f29.svg"
import Classify from "../assets/svg/svg_icons/classify_white.svg";
import Eoaf from "../assets/svg/svg_icons/eoaf_white.svg";
import Balance from "../assets/svg/svg_icons/balance_white.svg";
import Holding from "../assets/svg/svg_icons/holding.svg";




import "./_nav.scss";

const height = "25px";
const width = "25px";

const entry = process.env.REACT_APP_ENTRY

const _nav = [
  {
    _tag: "CSidebarNavItem",
    icon: (
      <div className="_nav_center">
        <Popup
          inverted
          content={"Dashboard"}
          position="right center"
          trigger={
            <img
              className="_nav_icon"
              style={{ height, width }}
              src={Dashboard}
              alt="logo"
            />
          }
        ></Popup>
        <span className="_nav_title">Dashboard</span>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2",
    to: "/dashboard",
  },
  {
    _tag: "CSidebarNavItem",
    icon: (
      <div className="_nav_center">
        <Popup
          inverted
          content={"Flujo de Caja"}
          position="right center"
          trigger={
            <img
              className="_nav_icon"
              style={{ height, width }}
              src={Cashflow}
              alt="logo"
            />
          }
        ></Popup>
        <span className="_nav_title">Flujo de Caja</span>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2",
    to: "/flujo_caja",
  },
  {
    _tag: "CSidebarNavItem",
    icon: (
      <div className="_nav_center">
        <Popup
          inverted
          content={"Estado de Resultados"}
          position="right center"
          trigger={
            <img
              className="_nav_icon"
              style={{ height, width }}
              src={Classify}
              alt="logo"
            />
          }
        ></Popup>
        <span className="_nav_title">Estado de Resultados</span>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2 ",
    to: "/eerr",
  },
  {
    _tag: "CSidebarNavItem",
    icon: (
      <div className="_nav_center">
        <Popup
          inverted
          content={"EOAF"}
          position="right center"
          trigger={
            <img
              className="_nav_icon"
              style={{ height, width }}
              src={Eoaf}
              alt="logo"
            />
          }
        ></Popup>
        <span className="_nav_title">EOAF</span>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2 ",
    to: "/eoaf",
  },
  {
    _tag: "CSidebarNavItem",
    icon: (
      <div className="_nav_center">
        <Popup
          inverted
          content={"Conciliación Bancaria"}
          position="right center"
          trigger={
            <img
              className="_nav_icon"
              style={{ height, width }}
              src={Reconcile}
              alt="logo"
            />
          }
        ></Popup>
        <span className="_nav_title">Conciliación Bancaria</span>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2 ",
    to: "/conciliacion",
  },
  {
    _tag: "CSidebarNavItem",
    icon: (
      <div className="_nav_center">
        <Popup
          inverted
          content={"Pago a Proveedores"}
          position="right center"
          trigger={
            <img
              className="_nav_icon"
              style={{ height, width }}
              src={Nomina}
              alt="logo"
            />
          }
        ></Popup>
        <span className="_nav_title">Pago a Proveedores</span>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2",
    to: "/pago_proveedores",
  },
  {
    _tag: "CSidebarNavItem",
    icon: (
      <div className="_nav_center">
        <Popup
          inverted
          content={"Cuadratura"}
          position="right center"
          trigger={
            <img
              className="_nav_icon"
              style={{ height, width }}
              src={Balance}
              alt="logo"
            />
          }
        ></Popup>
        <span className="_nav_title">Cuadratura</span>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2",
    to: "/cuadratura",
  },
  {
    _tag: "CSidebarNavItem",
    icon: (
      <div className="_nav_center">
        <Popup
          inverted
          content={"Documentos"}
          position="right center"
          trigger={
            <img
              className="_nav_icon"
              style={{ height, width }}
              src={Documents}
              alt="logo"
            />
          }
        ></Popup>
        <span className="_nav_title">Documentos</span>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2 ",
    to: "/documentos_tributarios",
  },
  {
    _tag: "CSidebarNavItem",
    icon: (
      <div className="_nav_center">
        <Popup
          inverted
          content={"Préstamos"}
          position="right center"
          trigger={
            <img
              className="_nav_icon"
              style={{ height, width }}
              src={Credits}
              alt="logo"
            />
          }
        ></Popup>
        <span className="_nav_title">Préstamos</span>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2",
    to: "/creditos",
  },
  {
    _tag: "CSidebarNavItem",
    icon: (
      <div className="_nav_center">
        <Popup
          inverted
          content={"Conexiones"}
          position="right center"
          trigger={
            <img
              className="_nav_icon"
              style={{ height, width }}
              src={Passwords}
              alt="logo"
            />
          }
        ></Popup>
        <span className="_nav_title">Conexiones</span>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2",
    to: "/conexiones",
  },
  {
    _tag: "CSidebarNavItem",
    icon: (
      <div className="_nav_center">
        <Popup
          inverted
          content={"Agenda"}
          position="right center"
          trigger={
            <img
              className="_nav_icon"
              style={{ height, width }}
              src={Agenda}
              alt="logo"
            />
          }
        ></Popup>
        <span className="_nav_title">Agenda</span>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2",
    to: "/agenda",
  },
  /* {
    _tag: "CSidebarNavItem",
    icon: (
      <div className="_nav_center">
        <Popup
          inverted
          content={"Usuarios"}
          position="right center"
          trigger={
            <img
              className="_nav_icon"
              style={{ height, width }}
              src={users}
              alt="logo"
            />
          }
        ></Popup>
        <span className="_nav_title">Usuarios</span>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2",
    to: "/usuarios",
  }, */
  {
    _tag: "CSidebarNavItem",
    icon: (
      <div className="_nav_center">
        <Popup
          inverted
          content={"Reportes"}
          position="right center"
          trigger={
            <img
              className="_nav_icon"
              style={{ height, width }}
              src={Reports}
              alt="logo"
            />
          }
        ></Popup>
        <span className="_nav_title">Reportes</span>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2",
    to: "/reportes",
  },
  {
    _tag: "CSidebarNavItem",
    icon: (
      <div className="_nav_center">
        <Popup
          inverted
          content={"Reportes DJ"}
          position="right center"
          trigger={
            <img
              className="_nav_icon"
              style={{ height, width }}
              src={Reports}
              alt="logo"
            />
          }
        ></Popup>
        <span className="_nav_title">Reportes DJ</span>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2",
    to: "/reportes_dj",
  },
  /*   {
    _tag: "CSidebarNavItem",
    icon: (
      <div className="_nav_center">
        <Popup
          inverted
          content={"Mi cuenta"}
          position="right center"
          trigger={
            <img
            className="_nav_icon"
            style={{ height, width }}
            src={cuentaIcon}
            alt="logo"
          />
          }
        >
        </Popup>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2",
    to: "/cuenta",
  }, */
  /*{
    _tag: "CSidebarNavItem",
    name: "Agregar Empresa",
    icon: (
      <img
        className="_nav_icon"
        style={{ height, width }}
        src={agregarEmp}
        alt="logo"
      />
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper-reset py-2 agregar-empresa-link",
    to: "/empresa",
  },*/
  {
    _tag: "CSidebarNavItem",
    icon: (
      <div className="_nav_center">
        <Popup
          inverted
          content={"Cobranza"}
          position="right center"
          trigger={
            <img
              className="_nav_icon"
              style={{ height: "30px", width }}
              src={Cobranza}
              alt="logo"
            />
          }
        ></Popup>
        <span className="_nav_title">Cobranza</span>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2",
    to: "/cobranza",
  },
  {
    _tag: "CSidebarNavItem",
    icon: (
      <div className="_nav_center">
        <Popup
          inverted
          content={"F29"}
          position="right center"
          trigger={
            <img
              className="_nav_icon"
              style={{ height: "30px", width }}
              src={F29}
              alt="logo"
            />
          }
        ></Popup>
        <span className="_nav_title">F-29</span>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2",
    to: "/f-29",
  },
  {
    _tag: "CSidebarNavItem",
    icon: (
      <div className="_nav_center">
        <Popup
          inverted
          content={"Configuración"}
          position="right center"
          trigger={
            <img
              className="_nav_icon"
              style={{ height: "30px", width }}
              src={Settings}
              alt="logo"
            />
          }
        ></Popup>
        <span className="_nav_title">Configuración</span>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2",
    to: "/configuracion",
  },
  {
    _tag: "CSidebarNavItem",
    name: (
      <div className="_nav_center"
      onClick={() => {
        const newTab = window.open(entry, "_blank");

        setTimeout(() => {
          const token = localStorage.getItem("token"); 
          const user = localStorage.getItem("user"); 
          const persistRoot = localStorage.getItem("persist:root"); 
          // const holdingCompanies =['680aebff7514ac4534be820e', '680aed687514ac4534be8631'] //HARDCODED HOLDING EN DEVELOP PARA TESTING!!
          const holdingCompanies =[
            '6760156cac2d65001cb6256b',
            '678fd7e47f10bc001df0f5be',
            '678ff012ce119d001c920368',
            '678ff0752ebe32001bc5cc9d',
            '678ff0d99c76ff001c1db195',
            '678ff113ce119d001c92a0b9'
          ] //HARDCODED EMPRESAS HOLDING PRODUCCION!!

          newTab.postMessage(
            { type: "SET_TOKEN", token },
            entry
          );
          newTab.postMessage(
            { type: "SET_USER", user },
            entry
          );
          newTab.postMessage(
            { type: "SET_PERSIST_ROOT", persistRoot },
            entry
          );
          newTab.postMessage(
            { type: "HOLDING_COMPANIES", holdingCompanies },
            entry
          );
          newTab.postMessage({ type: "INIT_COMPLETE" }, entry);
          // newTab.postMessage(
          //   {
          //     type: "INIT_SESSION",
          //     payload: {
          //       token: localStorage.getItem("token"),
          //       user: localStorage.getItem("user"),
          //       persistRoot: localStorage.getItem("persist:root"),
          //     },
          //   },
          //   entry // Asegúrate de que "entry" sea la URL destino
          // );
        }, 1000);
      }}
      >
        <Popup
          inverted
          content={"Holding"}
          position="right center"
          trigger={
            <img
              className="_nav_icon"
              style={{ height: "25px", width }}
              src={Holding}
              alt="logo"
            />
          }
        ></Popup>
        <span className="_nav_title">Holding</span>
      </div>
    ),
    className: "",
    addLinkClass: "navbar-item-rounded-pepper py-2",
    to: "",
    isHolding:true
    
  }
];
export default _nav;
